<template>
  <el-dialog
    :title="dialogTitle"
    destroy-on-close
    :visible.sync="visible"
    width="65%"
    @close="closeHandle"
    modal-append-to-selector="body"
    append-to-selector="body"
  >
    <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="品牌" prop="brandName">
        <el-input style="width: 280px" v-model="formData.brandName" aria-placeholder="请输入品牌名称"></el-input>
      </el-form-item>
      <el-form-item label="适配店铺" prop="shopNames">
        <el-input
          clearable
          style="width: 280px"
          @clear="handleClear"
          readonly
          placeholder="请选择店铺"
          @focus="chooseShops"
          :value="formData.shopNames"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleBrandCancel">取 消</el-button>
      <el-button type="primary" @click="handleBrandSave('ruleForm')">确 定</el-button>
    </span>
    <el-dialog-select-shop
      :visible.sync="shopDialogVisible"
      :shopData="shopList"
      :selected="userIds"
      placeholder="店铺名称"
      modal-append-to-selector="body"
      append-to-selector="body"
      @confirm="confirmSelectShop"
    ></el-dialog-select-shop>
    <CheckBrandDialog ref="checkBrandDialog" />
  </el-dialog>
</template>

<script>
import { uniqueId, cloneDeep } from 'lodash';
import CheckBrandDialog from './checkBrandDialog';
import { mapGetters, mapActions } from 'vuex';
export default {
  props: {
    shopList: {
      type: Array,
      default: [],
    },
    tableData: {
      type: Array,
      default: [],
    },
    platform: {
      type: String,
      default: '',
    },
  },
  components: {
    CheckBrandDialog,
  },
  provide: {
    isBatchCategory: true,
  },
  data() {
    return {
      formData: {
        brandName: '',
        shopIds: [],
        shopNames: '',
      },
      shopDialogVisible: false,
      visible: false,
      visibleType: 'ADD',
      shopBrands: [],
      ruleForm: {
        brandName: '',
        shopNames: '',
      },
      shopBrandCatagorys: {},
      rules: {
        brandName: [
          { required: true, message: '请输入品牌', trigger: 'change' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'change' },
        ],
        shopNames: [{ required: true, message: '请选择至少一个店铺', trigger: 'change' }],
      },
      categoryRelationsList: {
        shopId: '',
        shopName: '',
        relations: [],
      },
      initData: {
        shopId: '',
        shopName: '',
        relations: [],
      },
      initCateData: {
        categoryId: '',
        // 品牌
        vvalue: '',
        vid: '',

        templatePid: '',
        refPid: '',
        valueUnit: '',

        parentCategoryIds: [],
        parentCategoryNames: [],
      },
      dialogTitle: '新增品牌配置',
      itemIndex: '',
    };
  },
  computed: {
    ...mapGetters(['brandConfigTableList']),
    userIds() {
      const ids = this.formData.shopIds.map(shopId => {
        const findItem = this.shopList.find(shop => shop.id == shopId)
        return findItem?.userId
      }).filter(Boolean).join(',')
      return ids
    }
  },
  watch: {},
  methods: {
    ...mapActions(['setBrandConfig']),
    handleClear(value) {
      this.formData.shopIds = [];
      this.formData.shopNames = '';
    },
    confirmSelectShop(list) {
      let userIdList = [],
        userIdNamesList = [];
      list.map(shop => {
        userIdList.push(shop.id);
        userIdNamesList.push(shop.shortTitle || shop.title);
      });

      this.formData.shopIds = userIdList;
      this.formData.shopNames = userIdNamesList.join(',');
    },
    chooseShops() {
      this.shopDialogVisible = true;
    },
    closeHandle() {
      this.visible = false;
      this.formData = {
        brandName: '',
        shopIds: [],
        shopNames: '',
      };
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        }
      });
    },
    method_open({ visibleType, categoryRow = {}, index }) {
      // 这里必须要有索引，编辑需要根据索引找到对应ID，删除对应数据
      this.visibleType = visibleType;
      this.visible = true;
      this.dialogTitle = visibleType == 'EDIT' ? '编辑品牌配置' : '新增品牌配置';
      this.itemIndex = categoryRow?.id || '';
      console.log(JSON.parse(JSON.stringify(this.formData)), JSON.parse(JSON.stringify(categoryRow)), '---categoryRow-')
      this.formData = {
        ...this.formData,
        ...categoryRow,
        shopNames: (categoryRow?.shopNames || []).join(',')
      };
    },

    // 校验品牌店铺是否唯一性
    checkBrandShop() {
      // 1. 获取权威的品牌列表作为数据源
      const currentBrandList = this.brandConfigTableList?.length ? this.brandConfigTableList : this.tableData;

      // 2. 准备用于冲突检查的数据
      const payload = cloneDeep(this.formData);
      // 确保 shopNames 始终为数组，以便进行一致性处理
      payload.shopNames = Array.isArray(payload.shopNames) ? payload.shopNames : payload.shopNames ? payload.shopNames.split(',') : [];

      // 在编辑模式下，检查冲突时应排除当前正在编辑的项
      const listToCheck = this.visibleType === 'EDIT' ? currentBrandList.filter(item => item.id !== payload.id) : currentBrandList;

      // 3. 检查是否存在店铺冲突
      const conflictingShopIds = payload.shopIds.filter(id => listToCheck.some(brand => brand.shopIds.includes(id)));

      // 4. 根据冲突检查结果执行操作
      if (conflictingShopIds.length === 0) {
        // 无冲突，直接更新列表
        const newList = this._getUpdatedList(currentBrandList, payload, this.visibleType);
        this._updateState(newList);
      } else {
        // 有冲突，弹出二次确认对话框
        const conflictingShopNames = payload.shopNames.filter(name => listToCheck.some(brand => brand.shopNames.includes(name)));
        this.$refs.checkBrandDialog.method_open({ conflictingShopNames, platform: this.platform }, userChoice => {
          const checkTypeMap = { 跳过: 'jump', 绑定新配置: 'bindNewSet' };
          this.handleTwiceConfirm(checkTypeMap, userChoice, conflictingShopIds);
        });
      }
    },

    // 处理二次确认的结果
    handleTwiceConfirm(checkTypeMap, userChoice, conflictingShopIds) {
      const currentBrandList = this.brandConfigTableList?.length ? this.brandConfigTableList : this.tableData;
      let payload = cloneDeep(this.formData);
      payload.shopNames = Array.isArray(payload.shopNames) ? payload.shopNames : payload.shopNames.split(',');

      if (userChoice === checkTypeMap['跳过']) {
        // 方案一：从当前提交的品牌中移除冲突的店铺
        payload.shopIds = payload.shopIds.filter(id => !conflictingShopIds.includes(id));
        payload.shopNames = payload.shopNames.filter(
          name => !this.shopList.find(s => conflictingShopIds.includes(s.id) && (s.title === name || s.shortTitle === name))
        );

        if (payload.shopIds.length > 0) {
          const newList = this._getUpdatedList(currentBrandList, payload, this.visibleType);
          this._updateState(newList);
        } else {
          this.closeHandle(); // 如果所有店铺都冲突，则不执行任何操作
        }
      } else if (userChoice === checkTypeMap['绑定新配置']) {
        // 方案二：为新品牌绑定所有店铺，并从旧品牌中解除这些店铺的绑定

        // 1. 创建包含新/已编辑品牌的新列表
        const listWithNewItem = this._getUpdatedList(currentBrandList, payload, this.visibleType);
        const savedItem =
          listWithNewItem.find(item => item.brandName === payload.brandName && item.shopIds.join() === payload.shopIds.join()) ||
          listWithNewItem[listWithNewItem.length - 1];

        // 2. 从所有其他品牌中移除冲突的店铺
        const finalBrandList = listWithNewItem
          .map(brand => {
            if (brand.id !== savedItem.id) {
              // 只处理非当前保存项
              brand.shopIds = brand.shopIds.filter(id => !conflictingShopIds.includes(id));
              brand.shopNames = brand.shopNames.filter(
                name => !this.shopList.find(s => conflictingShopIds.includes(s.id) && (s.title === name || s.shortTitle === name))
              );
            }
            return brand;
          })
          .filter(brand => brand.shopIds.length > 0); // 3. 移除处理后没有店铺的品牌

        this._updateState(finalBrandList);
      } else {
        console.log('操作已取消');
      }
    },

    // 辅助方法：根据旧列表和操作，返回一个新的列表
    _getUpdatedList(sourceList, payload, type) {
      const newList = cloneDeep(sourceList);
      if (type === 'EDIT') {
        const index = newList.findIndex(item => item.id === payload.id);
        if (index !== -1) {
          newList[index] = payload;
        }
      } else {
        // ADD ID必须要有店铺ID和索引构成，这样才能找到独赢的索引对应的ID删除，光根据索引不行
        let id = newList.length + '_' + payload.shopIds.join('')
        newList.push({ ...payload, id });
      }
      return newList;
    },

    // 辅助方法：集中更新状态和关闭弹窗
    _updateState(newBrandList) {
      this.$emit('change', newBrandList);
      this.setBrandConfig(newBrandList);
      this.closeHandle();
    },

    // 保存按钮的入口
    handleBrandSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.checkBrandShop();
        }
      });
    },

    handleBrandCancel() {
      this.closeHandle();
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.base {
  padding: 0 18px;
  ::v-deep .el-cascader {
    width: 755px !important;
  }
}
</style>